// extracted by mini-css-extract-plugin
export default {"spinner":"BouncingDots_spinner__GMDJ2","sk-bouncedelay":"BouncingDots_sk-bouncedelay__xjIdt","bounce1":"BouncingDots_bounce1__c6avY","bounce2":"BouncingDots_bounce2__kFMsJ"};